import { useEffect, useRef } from 'react';

export default function CursorParticles() {
  const particles = useRef([]);
  const isTouch = useRef(false);

  useEffect(() => {
    isTouch.current = 'ontouchstart' in window;
    if (isTouch.current) return;

    const onMove = (e) => {
      if (particles.current.length >= 8) return;
      const el = document.createElement('div');
      el.className = 'cursor-particle';
      el.style.left = `${e.clientX - 2}px`;
      el.style.top = `${e.clientY - 2}px`;
      document.body.appendChild(el);
      particles.current.push(el);
      setTimeout(() => {
        el.remove();
        particles.current = particles.current.filter(p => p !== el);
      }, 800);
    };

    let throttle = false;
    const throttledMove = (e) => {
      if (throttle) return;
      throttle = true;
      requestAnimationFrame(() => { onMove(e); throttle = false; });
    };

    window.addEventListener('mousemove', throttledMove, { passive: true });
    return () => window.removeEventListener('mousemove', throttledMove);
  }, []);

  return null;
}
